import React, { useState } from 'react';
import ReactTable from "react-table";
import treeTableHOC from "react-table/lib/hoc/treeTable";
import {
	Card,
	CardBody,
	CardTitle,
	Button, Modal, ModalHeader, ModalBody, Form, FormGroup, Label, Input, Row, Col,
	ButtonGroup,
} from 'reactstrap';
import "react-table/react-table.css";
import * as data from "../tables/reactable-data";
import Switch from "react-switch";
import avatar from '../../assets/images/users/3.jpg'
import Select, { components } from 'react-select'
import countryList from 'react-select-country-list'
// import { SelectTimezone } from 'react-select-timezone';
import { auth } from '../../Api';
import ImageUploader from 'react-images-upload';
import { baseURL, baseImgURL } from '../../Api/BaseApi';
import 'react-phone-number-input/style.css'
import PhoneList from '../../components/people/phoneList'
import { dialCodeFor, phoneListRequest } from '../../utils/phone'
import { MAX_FIELD_LENGTH, isFieldTooLong } from '../../utils/fieldLimits'
import { formatServerMessage } from '../../utils/serverErrors'
import { personName, isSharedPhoneReply, sharedPhoneState, confirmedSharedPhoneRequest } from '../../utils/people'
import CidField from '../../components/people/cidField'
import SharedPhoneModal from '../../components/people/sharedPhoneModal'
import { leaveForm } from '../../utils/formReturn'
import EditButtons, { markChanged, withChange } from '../../components/forms/editButtons'
import { isDistrictManager, ownDistrictPicks } from '../../utils/adminLevel'

class CompanyView extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			checked: false,
			open: false,
			modal: false,
			obj: {},
			checked: true,
			jsonData: data.dataTable,
			guardData: [],
			data: data.makeData(),
			treedata: data.treedata,
			options: countryList().getData(),
			firstName: '',
			secondName: '',
			CID: '',
			phoneValue: '',
			otherPhones: [],
			timeValue: '',

			avatarUrl: '/storage/avatar.jpg',
			center: {
				lat: 59.95,
				lng: 30.33
			},
			zoom: 11,
			superId: "null",
			company_id: "",
			countryOption: null,
			districtLst: [],
			districtOption: null,
			managerLst: [],
			managerOption: null,
			guardLst: [],
			guardOption: null,
			showAlert: false,
			showResult: false,
			pictures: [],
			modalEdit: false,
			modalCancel: false,
			defaultCountry: null,
			selectedCountry: null,
			sharedPhone: null
		};
		this.toggle = this.toggle.bind(this);
		this.onDrop = this.onDrop.bind(this);
		this.toggleEdit = this.toggleEdit.bind(this);
		this.toggleCancel = this.toggleCancel.bind(this);
	}
	componentDidMount() {
		let { guardLst } = this.state
		const { id } = this.props.match.params
		let companyId = localStorage.getItem('companyId')
		let companyName = localStorage.getItem('companyName');
		let { districtLst } = this.state
		this.setState({
			superId: id,
			company_id: companyId,
			companyName: companyName
		})
		auth.getCompany({ id: companyId })
			.then((res) => {
				if (res.data.code == 200) {
					let companyData = res.data.message.users[0];
					this.setState({ defaultCountry: companyData.countrycode, dialCode: dialCodeFor(companyData.countrycode) });
					if (id == "null") {
						this.setState({ selectedCountry: companyData.countrycode });
					}
				}
			});
		var req = {}
		req.company_id = companyId
		auth.getDistrict(req)
			.then((res) => {
				districtLst = []
				if (res.data.code == 200) {
					res.data.message.users.forEach(element => {
						districtLst.push({ value: element.id.toString(), label: element.name })
					});
					this.setState({ districtLst })
					// A district manager: their district and themselves
					const own = ownDistrictPicks()
					if (own && !this.state.districtOption) {
						this.setState(own)
					}
				}
			})
		var req = {}
		req.id = id
		req.company_id = localStorage.getItem('companyId')
		if (id != "null") {
			auth.getSupervisor(req)
				.then((res) => {
					console.log("res:", res)
					if (res.data.code == 200) {
						let supervisorData = res.data.message.users[0]
						let guardData = res.data.message.guards
						this.setState({
							avatarUrl: supervisorData.avatar,
							firstName: supervisorData.firstname,
							secondName: supervisorData.secondname,
							CID: supervisorData.CID,
							phoneValue: supervisorData.phone,
							// The person's other numbers (the first is "phone")
							otherPhones: (supervisorData.phones || []).slice(1),
							districtOption: { value: supervisorData.district_id, label: supervisorData.district },
							managerOption: { value: supervisorData.districtmanager_id, label: supervisorData.districtmanager },
							guardData: guardData,
							selectedCountry: supervisorData.countrycode
						})
					}

				})
			req.company_id = companyId
			auth.unAssignGuard(req)
				.then((res) => {
					console.log("res:", res);
					guardLst = []
					// Guards with no supervisor first, then other supervisors' guards with their supervisor's name
					const users = (res.data.message && res.data.message.users) || []
					users.forEach(element => {
						const name = personName(element, 'guard')
						guardLst.push({ value: element.id, label: element.supervisor_name ? `${name} (${element.supervisor_name})` : name })
					})
					this.setState({ guardLst })
				})
		}
	}

	toggle() {
		this.setState({
			showAlert: !this.state.showAlert
		});
	}

	toggleEdit() {
		this.setState({
			modalEdit: !this.state.modalEdit
		});
	}
	toggleCancel() {
		this.setState({
			modalCancel: !this.state.modalCancel
		});
	}

	districtChange = (e) => {
		let { managerLst } = this.state
		this.setState({
			districtOption: e,
		})
		console.log("e.distirct:", e);
		var district_id = e.value
		var req = {}
		req.district_id = district_id

		auth.getDistrictManager(req)
			.then((res) => {
				managerLst = []
				if (res.data.code == 200) {
					res.data.message.users.forEach(element => {
						managerLst.push({ value: element.id, label: personName(element, 'manager') })
					})
				}
				this.setState({ managerLst })
			})
		this.componentDidMount()
	}
	managerChange = (e) => {
		this.setState({
			managerOption: e,
		})
		console.log("e.managerID:", e)
	}
	guardChange = (e) => {
		this.setState({
			guardOption: e,
		})
		console.log("e.managerID:", e)
	}

	assignGuard = () => {
		let { guardOption, superId } = this.state
		if (guardOption != null) {
			let req = {}
			req.id = guardOption.value
			req.super_id = superId

			this.setState({ modalEdit: false })
			auth.assignGuard(req)
				.then((res) => this.afterAssignChange(res, 'The guard could not be assigned.'))
				.catch(() => this.afterAssignChange(null, 'The guard could not be assigned.'))
		}
	}
	// Takes the guard off this supervisor (laravel guard/assignCancel: the guard must be in reach and assigned to them)
	assignCancel = () => {
		let { obj, superId } = this.state
		let req = {}
		req.id = obj.id
		req.super_id = superId

		this.setState({ modalCancel: false })
		auth.assignCancel(req)
			.then((res) => this.afterAssignChange(res, 'The guard could not be taken off this supervisor.'))
			.catch(() => this.afterAssignChange(null, 'The guard could not be taken off this supervisor.'))
	}

	afterAssignChange(res, fallback) {
		if (res && res.data && Number(res.data.code) === 201) {
			this.setState({ guardOption: null })
			this.componentDidMount()
			return
		}
		const error = res && res.data && res.data.message && res.data.message.error
		this.setState({ showAlert: true, alertMessage: error || fallback })
	}

	setPhoneNumber = (event) => {
		console.log("event of phone:", event)
		this.setState({
			phoneValue: event
		})
	}

	handleChange = (event) => {
		console.log(["event.valu:", event.target.value, event.target.name])
		switch (event.target.name) {
			case "firstName":
				this.setState({
					firstName: event.target.value
				})
				break;
			case "secondName":
				this.setState({
					secondName: event.target.value
				})
				break;
			case "phone":
				this.setState({
					phoneValue: event.target.value
				})
				break;
		}
	}
	onSave = (event) => {
		let { emailValue, phoneValue, firstName, secondName, CID, superId,
			avatarUrl, company_id,
			districtOption, managerOption
		} = this.state
		this.setState({ showResult: false });
		var req = {}
		req.firstname = firstName
		req.secondname = secondName
		// No CID: Mobiliis gives it (shown after saving)
		// The local number completed with the company's dialling code (null when it is not usable)
		// Every number, each completed with the company's dialling code; the first is the main one
		const phoneList = phoneListRequest([phoneValue].concat(this.state.otherPhones), this.state.dialCode)
		req.phone = phoneList.phone
		req.phones = phoneList.phones
		req.email = emailValue
		req.company_id = company_id
		req.avatar = avatarUrl
		req.countrycode = this.state.selectedCountry || this.state.defaultCountry
		if (districtOption != null) {
			req.district = districtOption.label
			req.district_id = districtOption.value
		}
		if (managerOption != null)
			req.districtmanager_id = managerOption.value
		var that = this;
		let alertMessage = "";
		if (!req.firstname || req.firstname.trim() === '') {
			alertMessage = 'Please enter a First name.'
			that.setState({
				showAlert: true,
				showResult: false,
				alertMessage: alertMessage
			})
		}
		else if (isFieldTooLong(req.firstname)) {
			alertMessage = 'First name must be ' + MAX_FIELD_LENGTH + ' characters or fewer.'
			that.setState({
				showAlert: true,
				showResult: false,
				alertMessage: alertMessage
			})
		}
		else if (!req.secondname || req.secondname.trim() === '') {
			alertMessage = 'Please enter a Last name.'
			that.setState({
				showAlert: true,
				showResult: false,
				alertMessage: alertMessage
			})
		}
		else if (isFieldTooLong(req.secondname)) {
			alertMessage = 'Last name must be ' + MAX_FIELD_LENGTH + ' characters or fewer.'
			that.setState({
				showAlert: true,
				showResult: false,
				alertMessage: alertMessage
			})
		}
		else if (req.phone === null) {
			that.setState({
				showAlert: true,
				showResult: false,
				alertMessage: phoneList.problem
			})
		}
		else if (districtOption == null) {
			alertMessage = 'Please select District'
			that.setState({
				showAlert: true,
				showResult: false,
				alertMessage: alertMessage
			})
		}
		else if (managerOption == null) {
			alertMessage = 'Please select District Manager'
			that.setState({
				showAlert: true,
				showResult: false,
				alertMessage: alertMessage
			})
		}
		else if (!req.countrycode) {
			alertMessage = 'Please wait for the page to finish loading, then try saving again.'
			that.setState({
				showAlert: true,
				showResult: false,
				alertMessage: alertMessage
			})
		}
		else {
			if (superId != "null") {
				req.id = superId
			}
			this.send(req)
		}
		event.preventDefault();
	}

	// Saves the supervisor. A phone number someone else in the company also has is asked about first
	// (code 409); Yes sends it again with confirm_shared_phone.
	send = (req) => {
		const isUpdate = this.state.superId != "null"
		const save = isUpdate ? auth.updateSupervisor : auth.registerSupervisor
		save(req)
			.then((res) => {
				if (isSharedPhoneReply(res)) {
					this.setState({ sharedPhone: sharedPhoneState(res, req, 'supervisor') })
				}
				else if (res.data.code == 201) {
					// Back to the page the form was opened from, or the supervisor's page
					const id = isUpdate ? this.state.superId : res.data.message && res.data.message.id
					leaveForm(this.props.history, id ? '/supervisor-info/' + id : '/supervisor')
				}
				else {
					// e.g. "The CID 1234 is already used by Jo Bloggs (guard)"
					this.setState({
						showAlert: true,
						showResult: false,
						alertMessage: formatServerMessage(res.data.message, 'The supervisor could not be saved.')
					})
				}
			})
	}

	// samePerson: the person of another kind the admin said this is (Yes), or null (No, or Continue)
	confirmSharedPhone = (samePerson) => {
		const { req } = this.state.sharedPhone
		// Saved with that person's CID: the form shows it
		this.setState(samePerson ? { sharedPhone: null, CID: samePerson.cid } : { sharedPhone: null })
		this.send(confirmedSharedPhoneRequest(req, samePerson))
	}

	onDrop(picture) {
		var req = {}
		req.file = picture[0]
		console.log("req:", req);
		var that = this;
		auth.upload(req)
			.then((res) => {
				if (res.data.code == 201) {
					var avatarL = res.data.url.split("/")
					that.setState({
						avatarUrl: avatarL[avatarL.length - 1]
					})
				}
			})
		this.setState({
			pictures: this.state.pictures.concat(picture),
		});
	}

	// Exit edit page / Discard changes: leaves without saving, back where the form was opened from (or the record's page)
	exitForm = () => {
		const id = this.props.match && this.props.match.params ? this.props.match.params.id : null
		leaveForm(this.props.history, ((id) => id && id !== 'null' ? '/supervisor-info/' + id : '/supervisor')(id))
	}

	render() {
		const { superId, districtOption, districtLst, managerLst, managerOption, avatarUrl, companyName, guardLst, guardOption } = this.state;
		const data2 = this.state.guardData.map((prop, key) => {
			return {
				id: key,
				name: <div onClick={() => this.props.history.push('/guard-info/' + prop.id)} style={{ cursor: "pointer" }}>{personName(prop, 'guard')}</div>,
				CID: prop.CID,
				actions: (
					// we've added some custom button actions
					<div className="text-center">
						{prop.active == 1 ? "TRue" : "FALSE"}
					</div>
				),
				edit: (
					<div>
						<button onClick={() => {
							let obj = data2.find(o => o.id === key);
							console.log(["key:", key, obj.name]);
							this.setState({
								modalCancel: !this.state.modalCancel,
								obj: prop,
							});
						}}>Cancel</button>
					</div>

				)
			};
		});

		return <div>
			<Card>
				<Row className="toolbar up-card-title">
					<div className="b-title"><i className="ti-map-alt mr-10"></i>&nbsp;Supervisor Information</div>
					{/* <a href="/duty">
                        <div className="b-title-end">View Location Duties&nbsp;<i className="ti-align-left"></i></div>
                    </a> */}
				</Row>
				<Row className="toolbar up-card-box justify-content-center">
					<div className="col-md-3" style={{ textAlign: "center" }}>
						<img src={avatarUrl != "" ? avatarUrl == "/storage/avatar.jpg" ? avatar : baseImgURL + avatarUrl : avatar} className="img-company"></img>
						<Form>
							<FormGroup>
								{/* <Input type="file" name="file" id="exampleFile" onChange={withChange(this, this.onDrop)} /> */}
								<ImageUploader
									withIcon={false}
									buttonText='Choose images'
									onChange={withChange(this, this.onDrop)}
									accept='image/jpeg,image/png'
									imgExtension={['.jpg', '.jpeg', '.png']}
									maxFileSize={204800}
									label='Max file size: 200KB, max dimensions: 360x360px, accepted: jpg, png'
									singleImage={true}
								/>
							</FormGroup>
						</Form>
					</div>
					<form className="col-md-7" name="myForm" onSubmit={this.onSave} onChangeCapture={markChanged(this)}>
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">First name</label>
							<div className="col-md-9">
								<input className="location-text-input" name="firstName" type="text" value={this.state.firstName} onChange={withChange(this, this.handleChange)} required></input>
							</div>
						</Row>
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">Last name</label>
							<div className="col-md-9">
								<input className="location-text-input" name="secondName" type="text" value={this.state.secondName} onChange={withChange(this, this.handleChange)} required></input>
							</div>
						</Row>
						{/* Given by Mobiliis: read-only, shown once saved */}
						<CidField cid={this.state.CID} />
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">Phone</label>
							<div className="col-md-9">
								<PhoneList
									dialCode={this.state.dialCode}
									phones={[this.state.phoneValue].concat(this.state.otherPhones)}
									editing={{ kind: 'supervisor', id: this.state.superId }}
									onChange={(list) => this.setState({ phoneValue: list[0] || '', otherPhones: list.slice(1) })} />
							</div>
						</Row>
						<Row className="company-text-area">
							<label className="col-md-3 control-label">District</label>
							<div className="col-md-9">
								<Select name="district_id" options={districtLst} value={districtOption}
									onChange={withChange(this, this.districtChange)} isDisabled={isDistrictManager()} required />
							</div>
						</Row>
						<Row className="company-text-area">
							<label htmlFor="address" className="col-md-3 control-label">District Manager</label>
							<div className="col-md-9">
								<Select isDisabled={isDistrictManager()} options={managerLst} value={managerOption} onChange={withChange(this, this.managerChange)}></Select>
							</div>
						</Row>
						<div className="height-10"></div>
						<EditButtons changed={this.state.formChanged} onExit={this.exitForm} />
						<div className="height-10"></div>
					</form>
				</Row>
			</Card>
			{superId != "null" ? <Card>
				<CardBody>
					<div className="add-button add-button-top">
						<Button className="btn" color="primary" size="lg" active onClick={this.toggleEdit}>
							<i className="fas fa-user-plus"></i>&nbsp; Assign New Guard
						</Button>
					</div>
					<Row className="table-header">
						<div className="table-title"><i className="fas fa-users"></i><span> Guards - {companyName}</span></div>
					</Row>
					<ReactTable
						columns={[
							{
								Header: "No",
								id: "row",
								maxWidth: 50,
								filterable: false,
								Cell: (row) => {
									return <div>{row.index + 1}</div>;
								}
							},
							{
								Header: "Name",
								accessor: "name"
							},
							{
								Header: "CID",
								accessor: "CID"
							},
							{
								Header: "Active Guard",
								accessor: "actions"
							},
							{
								Header: "",
								accessor: "edit",
								id: "row",
								maxWidth: 100,
								filterable: false,
							},
						]}
						defaultPageSize={10}
						showPaginationBottom={true}
						className="-striped -highlight"
						data={data2}
					// filterable
					/>
				</CardBody>
			</Card>
				: <div></div>}
			<Modal isOpen={this.state.showAlert} toggle={this.toggle}>
				{/* <ModalHeader toggle={this.alertToggle}>Alert Modal</ModalHeader> */}
				<ModalBody className="alert-body">
					<i className="mdi mdi-alert-circle ft-60"></i>
					<h2>{this.state.alertMessage}</h2>
					<div className="height-10"></div>
					<FormGroup>
						<Button color="secondary" style={{ width: '100px' }} className="ml-1" onClick={this.toggle}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" style={{ width: '100px' }} onClick={this.toggle}>Ok</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<Modal isOpen={this.state.modalEdit} toggle={this.toggleEdit}>
				<ModalHeader toggle={this.toggleEdit}>Assign-Guard</ModalHeader>
				<ModalBody className="alert-body">
					<Select options={guardLst} value={guardOption} onChange={this.guardChange}></Select>
					<div style={{ height: "50px" }}></div>
					<FormGroup>
						<Button color="secondary" style={{ width: '100px' }} className="ml-1" onClick={this.toggleEdit}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" style={{ width: '100px' }} onClick={this.assignGuard}>Ok</Button>
					</FormGroup>
				</ModalBody>
			</Modal>

			<Modal isOpen={this.state.modalCancel} toggle={this.toggleCancel}>
				<ModalHeader toggle={this.toggleCancel}>Assign-Guard</ModalHeader>
				<ModalBody className="alert-body">
					<h2>Are you sure to cancel assignment?</h2>
					<FormGroup>
						<Button color="secondary" style={{ width: '100px' }} className="ml-1" onClick={this.toggleCancel}>Cancel</Button>
						<span>&nbsp;&nbsp;</span>
						<Button color="primary" style={{ width: '100px' }} onClick={this.assignCancel}>Ok</Button>
					</FormGroup>
				</ModalBody>
			</Modal>
			<SharedPhoneModal
				isOpen={this.state.sharedPhone != null}
				message={this.state.sharedPhone ? this.state.sharedPhone.message : ''}
				details={this.state.sharedPhone ? this.state.sharedPhone.details : []}
				person={this.state.sharedPhone ? this.state.sharedPhone.person : null}
				onYes={this.confirmSharedPhone}
				onNo={() => this.confirmSharedPhone(null)}
				onCancel={() => this.setState({ sharedPhone: null })} />

		</div>
	}
}


export default CompanyView;
